"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _atlasHomepageCards = require("@ebi-gene-expression-group/atlas-homepage-cards");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var tabsId = "species-summary-tabs";
var SpeciesSummaryPanel = /*#__PURE__*/function (_React$Component) {
  function SpeciesSummaryPanel() {
    _classCallCheck(this, SpeciesSummaryPanel);
    return _callSuper(this, SpeciesSummaryPanel, arguments);
  }
  _inherits(SpeciesSummaryPanel, _React$Component);
  return _createClass(SpeciesSummaryPanel, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        speciesSummary = _this$props.speciesSummary,
        carouselCardsRowProps = _this$props.carouselCardsRowProps;
      return [/*#__PURE__*/_react["default"].createElement("ul", {
        key: "tabs",
        className: "tabs",
        "data-tabs": true,
        id: tabsId
      }, speciesSummary.map(function (_ref, idx) {
        var kingdom = _ref.kingdom;
        return /*#__PURE__*/_react["default"].createElement("li", {
          key: idx,
          className: "tabs-title".concat(idx === 0 ? " is-active" : ""),
          style: {
            textTransform: "capitalize"
          }
        }, /*#__PURE__*/_react["default"].createElement("a", {
          href: "#".concat(kingdom)
        }, kingdom));
      })), /*#__PURE__*/_react["default"].createElement("div", {
        key: "tabs-content",
        className: "tabs-content",
        "data-tabs-content": tabsId
      }, speciesSummary.map(function (_ref2, idx) {
        var kingdom = _ref2.kingdom,
          cards = _ref2.cards;
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: idx,
          className: "tabs-panel".concat(idx === 0 ? " is-active" : ""),
          id: kingdom
        }, /*#__PURE__*/_react["default"].createElement(_atlasHomepageCards.CarouselCardsRow, _extends({
          cards: cards
        }, carouselCardsRowProps)));
      }))];
    }

    // Since the tabs need $().foundation() to function properly, we provide an optional callback to be run on the
    // target DOM node once the component has been initially rendered
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onComponentDidMount();
    }
  }]);
}(_react["default"].Component);
SpeciesSummaryPanel.propTypes = {
  speciesSummary: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    kingdom: _propTypes["default"].string.isRequired,
    cards: _atlasHomepageCards.CarouselCardsRow.propTypes.cards
  })).isRequired,
  onComponentDidMount: _propTypes["default"].func,
  carouselCardsRowProps: _propTypes["default"].object
};
SpeciesSummaryPanel.defaultProps = {
  onComponentDidMount: function onComponentDidMount() {},
  responsiveCardsRowProps: {}
};
var _default = exports["default"] = SpeciesSummaryPanel;